<template>
  <el-dialog width="520px"
             v-dialog-drag
             title="体验版二维码"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="weChatQRcodeVisible">
      <div class="qrcode_wrap" v-loading="loading">
        <img :src="'data:image/png;base64,' + qrcode" alt="" width="360">
      </div>

  </el-dialog>
</template>
<script>
import { getTrialQrcode} from "@/api";

export default {
  name: "wechat_qrcode",
  props: {
    weChatQRcodeVisible: {
      type: Boolean,
      default: false,
    },
    weChatAppId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      qrcode:''
    }
  },
  created() {
    this.getTrialQrcode()
  },
  mounted() {

  },
  methods: {
    getTrialQrcode(){
      this.loading =true
      getTrialQrcode({
        resultType:1
      },{
        headers:{
          appid: this.weChatAppId,
        }
      }).then(res => {
        this.qrcode = res.data.qrcode
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleClickCancel() {
      this.$emit('update:weChatQRcodeVisible', false)
    },

  }
}
</script>
<style lang="scss" scoped>
.qrcode_wrap{
  height: 360px;
  margin:80px auto;
  img{
    display: block;
    margin: 0 auto;
  }
}

</style>
